import styled from "@emotion/styled";
import { textAlign } from "@mui/system";
import React from "react";
import colors from "../../../helpers/colors";
import PbStatusPillProps from "./PbStatusPillProps";
import { defaultFonts } from "../../../helpers/fonts";

const StatusPill = styled.div((props: { bg: string; color: string, minWidth: string }) => ({
  backgroundColor: props.bg,
  color: props.color,
  borderRadius: "999px",
  width: "fit-content",
  paddingRight: "10px",
  paddingLeft: "10px",
  paddingTop: "2px",
  paddingBottom: "2px",
  textAlign: "center",
  minWidth: props.minWidth,
  fontFamily: defaultFonts
}));

const PbStatusPill = (props: PbStatusPillProps): JSX.Element => {
  return (
    <StatusPill
      bg={colors[props.status].background}
      color={colors[props.status].text}
      minWidth={props.minWidth}
    >
      {props.text}
    </StatusPill>
  );
};

export default PbStatusPill;